<template lang="pug">
div(id="app") 
  router-view
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Portfolio Performance, Tracking und Optimierung',
    titleTemplate: '%s | Sigmafolio',
    meta: [
      {name: 'description', content:'Mehr als Portfoliotracking - Optimiere dein Depot mit dem kostenlosen Musterdepot von Sigmafolio'},
      {property: 'og:type', content: 'website'},
      {property: 'og:title', content: 'Sigmafolio'},
      {property: 'og:url', content:'https://www.sigmafol.io/'},
      {property: 'og:description', content:'Mehr als Portfoliotracking - Optimiere dein Depot mit dem kostenlosen Musterdepot von Sigmafolio'},
      {property: 'og:site_name', content:'Sigmafolio'},
      {property: 'og:image', content:'https://www.sigmafol.io/img/portfolio_snapshot2.62b46912.png'},
    ]
  },
}
</script>